"use client";

import { useEffect, useRef } from "react";
import { useFormStatus } from "react-dom";

type LoadingModalProps = { isOpen?: boolean };

export const LoadingModal = ({ isOpen = false }: LoadingModalProps) => {
  const modalRef = useRef<HTMLDialogElement>(null);

  const { pending } = useFormStatus();

  useEffect(() => {
    if (isOpen || pending) {
      modalRef.current?.showModal();
    } else {
      modalRef.current?.close();
    }
  }, [modalRef, isOpen, pending]);

  return (
    <dialog
      className="m-auto w-fit rounded-2xl border bg-card p-8 text-card-foreground shadow-sm backdrop:bg-black/50"
      ref={modalRef}
    >
      <img
        alt=""
        className="h-auto"
        height="149"
        src="/animations/loading.gif"
        width="150"
      />
    </dialog>
  );
};
